// Import core lib dependencies.
import { createSelector } from 'reselect';

// Config.
import Config			  from './config/config.js';

/**
 * <pre>
 * Sharing module Selectors(s).
 *
 * Summary of responsibilities:
 *
 *  - defines reusable selectors to retrieve state properties
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:Sharing
 * @namespace
 *
 * @type {Object}
 */
const Selectors = {};

/**
 * Selector to access shares property of Redux state for this module.
 *
 * @memberof module:Sharing.Selectors
 *
 * @param  {Object}  state  The Redux state.
 * @return {Object}  The value of the retrieved state property.
 */
const sharesSelector = (state) => state[Config.stateKey].shares;
Selectors.getShares = createSelector(
	[sharesSelector],
	(stateVal) => {
		return stateVal;
	}
);

export default Selectors;